module.exports = __webpack_public_path__ + "static/media/op.aabedbc6.png";